module.exports = __webpack_public_path__ + "static/img/20007 (2).7efc65b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20007 (2).webp
// module id = jdb8
// module chunks = 14